import { render, staticRenderFns } from "./AppMenuAdd.vue?vue&type=template&id=c8c0f67c&scoped=true"
import script from "./AppMenuAdd.vue?vue&type=script&lang=ts"
export * from "./AppMenuAdd.vue?vue&type=script&lang=ts"
import style0 from "./AppMenuAdd.vue?vue&type=style&index=0&id=c8c0f67c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c0f67c",
  null
  
)

export default component.exports